<template>
  <div>
    <!-- Table dialog servicios -->
    <el-dialog
      :title="title"
      :visible="isVisible"
      :close-on-click-modal="false"
      :before-close="handleClose"
      :fullscreen="false"
      top="5vh"
      width="800px"
      center
    >
      <center>
        <h3 style="margin-top: -20px">{{ auxTitle }}</h3>
      </center>
      <el-form :model="data">
        <el-row :gutter="24" v-if="!id">
          <el-col :span="6">
            <el-form-item label="Código postal">
              <el-input
                v-model="data.code"
                size="small"
                autocomplete="off"
                clearable
                type="number"
                maxlength="5"
                @clear="loadSectors()"
                @blur="loadSectors()"
                :disabled="data.loading"
                :loading="data.loading"
              >
              </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="Servicio">
              <el-select
                v-model="data.service"
                placeholder="Sin proveedor"
                size="small"
                clearable
                filterable
                :remote-method="querySearchAsync"
              >
                <el-option
                  v-for="service in services"
                  :key="service.uuid"
                  :label="`${service.carrier} / ${service.service}`"
                  :value="service.uuid"
                >
                  <span style="font-size: small;">
                    <i class="el-icon-postcard"></i>
                    {{ service.carrier }} / {{ service.service }}
                  </span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="Sector">
              <el-select
                v-model="data.sector"
                placeholder="Sin sector"
                size="small"
                clearable
                :disabled="data.loading"
                :loading="data.loading"
              >
                <el-option
                  v-for="sector in sectors"
                  :key="sector.uuid"
                  :value="sector.sector"
                >
                  <span style="font-size: small;">
                    {{ sector.state }} / {{ sector.city }} / {{ sector.sector }}
                  </span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="Deshabilitar">
              <el-select
                v-model="data.disabled"
                placeholder="Sin proveedor"
                size="small"
                clearable
                filterable
              >
                <el-option :label="'Shipper'" :value="'shipper'">
                  <span style="font-size: small;">
                    <i class="el-icon-postcard"></i>
                    Shipper
                  </span>
                </el-option>
                <el-option :label="'Recipient'" :value="'recipient'">
                  <span style="font-size: small;">
                    <i class="el-icon-postcard"></i>
                    Recipient
                  </span>
                </el-option>
                <el-option :label="'Ningúno'" :value="null">
                  <span style="font-size: small;">
                    <i class="el-icon-postcard"></i>
                    Ningúno
                  </span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="4">
            <el-form-item label="Cobertura">
              <el-switch
                v-model="data.covered"
                size="small"
                active-text="Si"
                inactive-text="No"
                inactive-color="#ff4949"
                active-color="#13ce66"
              >
              </el-switch>
            </el-form-item>
          </el-col>

          <el-col :span="5">
            <el-form-item label="Ocurre">
              <el-switch
                v-model="data.ocurre"
                size="small"
                active-text="Si"
                inactive-text="No"
                inactive-color="#ff4949"
                active-color="#13ce66"
              >
              </el-switch>
            </el-form-item>
          </el-col>

          <el-col :span="5">
            <el-form-item label="Dias de espera">
              <el-input
                v-model="data.days"
                size="small"
                autocomplete="off"
                clearable
                type="number"
                show-word-limit
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button
          type="success"
          icon="el-icon-check"
          @click="handleSave"
          round
          :loading="data.loading"
        >
          Guardar
        </el-button>
      </span>
    </el-dialog>
    <!-- END Table dialog servicios -->
  </div>
</template>

<script>
import { CSApi } from "@/libraries/api";

export default {
  name: "DialogPostalCode",
  components: {},
  props: [
    "id",
    "serviceId",
    "sectorId",
    "disabled",
    "postalCodesLit",
    "isVisible",
  ],
  data() {
    return {
      title: "",
      auxTitle: "",
      max_weight: {},
      data: {},
      services: [],
      originalServices: [],
      sectors: [],
    };
  },
  watch: {
    async isVisible() {
      // Action

      if (this.id) {
        // Edit

        let recordToEdit = this.postalCodesLit.find(
          (postalCode) =>
            postalCode.uuid === this.id &&
            postalCode.serviceUuid === this.serviceId &&
            postalCode.disabled === this.disabled &&
            postalCode.sector === this.sectorId
        );

        if (recordToEdit) {
          this.data = {
            sector: recordToEdit.sector,
            code: recordToEdit.postalCode,
            covered: recordToEdit.covered,
            outOfArea: false,
            outOfPickup: false,
            ocurre: recordToEdit.isOcurre,
            days: recordToEdit.days,
            service: recordToEdit.serviceUuid,
            disabled: recordToEdit.disabled,
          };

          this.title = `${recordToEdit.postalCode} (${recordToEdit.carrier} - ${recordToEdit.service})`;
          this.auxTitle = ` Deshabilitar para: ${recordToEdit.disabled ||
            "Ningúno"}`;
        }
      } else {
        // Create
        this.data = {
          sector: "",
          code: "",
          covered: true,
          outOfArea: false,
          outOfPickup: false,
          ocurre: false,
          days: 0,
          service: "",
          disabled: null,
        };

        this.title = `Nuevo Código postal`;

        const response = await CSApi().get(
          `/coverage/service?searchBy=&page=1&pageSize=500`
        );

        const { data } = response.data;
        this.services = data.filter((service) => service.countryCode == "MX");
        this.originalServices = structuredClone(this.services);
      }
    },
  },

  methods: {
    async querySearchAsync(queryString, cb) {
      try {
        let services = [];

        if (!queryString) {
          const response = await CSApi().get(
            `/coverage/service?searchBy=&page=1&pageSize=500`
          );

          const { data } = response.data;
          services = data.filter((service) => service.countryCode == "MX");
        } else {
          services = this.originalServices.filter(
            (service) =>
              service.carrier.includes(queryString) ||
              service.service.includes(queryString) ||
              `${service.carrier} / ${service.service}`.includes(queryString)
          );
        }

        this.services = services;

        cb(services);
      } catch (error) {
        console.error(error);
      }
    },

    async handleSave() {
      let options = {
        message: "Se guardaron los cambios con exito.",
        type: "success",
        duration: 4000,
      };

      try {
        this.data.loading = true;

        const body = [
          {
            sector: this.data.sector || "",
            code: this.data.code,
            covered: this.data?.covered ?? true,
            outOfArea: false,
            outOfPickup: false,
            ocurre: this.data?.ocurre || false,
            days: parseInt(this.data?.days) || 0,
            service: this.data.service,
            disabled: this.data.disabled,
          },
        ];

        const response = await CSApi().put(`/coverage/postalCode`, body);

        // If error
        if (!response?.data?.success)
          throw response?.data?.data?.error?.message || "Error";

        // If success
        this.update();
        this.handleClose();
      } catch (error) {
        options.showClose = true;
        options.message = error;
        options.type = "error";
      } finally {
        this.data.loading = false;

        this.$message(options);
      }
    },

    handleClose() {
      this.$emit("close");
    },

    update() {
      this.$emit("update");
    },

    async loadSectors() {
      try {
        // Reset sectors
        this.data.loading = true;
        this.sectors = [];

        // Get sectors by postal code from CS API
        const response = await CSApi().get(
          `/coverage/postalCode/${this.data.code}?page=1&pageSize=30&all=true`
        );
        if (response) this.sectors = response.data.data;
      } catch (error) {
        options.duration = 0;
        options.showClose = true;
        options.message = error;
        options.type = "error";
        this.$message(options);
      } finally {
        this.data.loading = false;
      }
    },
  },
};
</script>

<style>
.el-select-dropdown__item {
  padding: 10px 20px;
  height: 55px;
  width: 330px;
}
.el-form-item__label {
  font-size: 14px;
  font-weight: 100;
  line-height: 14px;
}
.el-switch__label * {
  line-height: 1;
  font-size: 14px;
  font-weight: 100;
}
.el-input .el-input--small .el-input--suffix {
  width: 260px;
}
</style>
